import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import HeadingAnchor from './heading-anchor';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import AnalyticsContext from '../../analytics/analyticsContext';
import { copyTextToClipboard } from '../utils/clipboard';
var getCurrentUrlWithHash = function getCurrentUrlWithHash() {
  var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var url = new URL(window.location.href);
  url.hash = encodeURIComponent(hash);
  return url.href;
};
function hasRightAlignmentMark(marks) {
  if (!marks || !marks.length) {
    return false;
  }
  return marks.some(function (mark) {
    return mark.type.name === 'alignment' && mark.attrs.align === 'end';
  });
}
function WrapChildTextInSpan(children) {
  // We wrap the text in a span so that we can apply CSS pseudo elements
  // to each text node within the heading element.
  return React.Children.map(children, function (child) {
    return typeof child === 'string' && !/^\s*$/.test(child) ? /*#__PURE__*/React.createElement("span", null, child) : child;
  });
}
function Heading(props) {
  var headingId = props.headingId,
    dataAttributes = props.dataAttributes,
    allowHeadingAnchorLinks = props.allowHeadingAnchorLinks,
    marks = props.marks,
    invisible = props.invisible;
  var HX = "h".concat(props.level);
  var showAnchorLink = !!props.showAnchorLink;
  var isRightAligned = hasRightAlignmentMark(marks);
  var enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
  var headingIdToUse = invisible ? undefined : headingId;
  return /*#__PURE__*/React.createElement(HX, _extends({
    id: headingIdToUse
  }, dataAttributes), /*#__PURE__*/React.createElement(React.Fragment, null, showAnchorLink && isRightAligned ? WrapChildTextInSpan(props.children) : props.children, showAnchorLink && headingId && /*#__PURE__*/React.createElement(AnalyticsContext.Consumer, null, function (_ref) {
    var fireAnalyticsEvent = _ref.fireAnalyticsEvent;
    return /*#__PURE__*/React.createElement(HeadingAnchor, {
      enableNestedHeaderLinks: enableNestedHeaderLinks,
      level: props.level,
      onCopyText: function onCopyText() {
        fireAnalyticsEvent({
          action: ACTION.CLICKED,
          actionSubject: ACTION_SUBJECT.BUTTON,
          actionSubjectId: ACTION_SUBJECT_ID.HEADING_ANCHOR_LINK,
          eventType: EVENT_TYPE.UI
        });
        return copyTextToClipboard(getCurrentUrlWithHash(headingId));
      }
    });
  })));
}
export default Heading;